import React from 'react'
import { Card, Button, Box, Typography, Grid } from '@mui/material'
import RFG from "../../libs/inputs/RFG"
import { useDispatch, useSelector } from "react-redux"
import { useForm } from 'react-hook-form'
import { LOGIN } from "../../services/actions"
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs"
import { useNavigate } from 'react-router-dom'
import authImg from './auth.jpeg'

export default function Login() {
  const navigate = useNavigate()
  let dispatch = useDispatch()
  let user = useSelector((state) => state?.loginState.auth)
  const { handleSubmit, control } = useForm({
    defaultValues: { "username": "admin@gmail.com", password: "Admin@123" },
    mode: "all"
  })

  const cardRef = React.useRef(null);

  React.useEffect(() => {
    const card = cardRef.current;

    const handleMouseMove = (e) => {
      const { offsetWidth: width, offsetHeight: height } = card;
      const { offsetX: x, offsetY: y } = e;

      const moveX = (x / width) * 30 - 15;
      const moveY = (y / height) * 30 - 15;

      card.style.boxShadow = `${moveX}px ${moveY}px 60px rgba(0, 0, 0, 0.6)`;
    };

    const handleMouseLeave = () => {
      card.style.boxShadow = '0 0 20px rgba(0, 0, 0, 0.1)';
    };

    card.addEventListener('mousemove', handleMouseMove);
    card.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      card.removeEventListener('mousemove', handleMouseMove);
      card.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);


  return (
    <>
      <Box display={'flex'} alignItems={'center'} justifyContent={'center'}
        sx={{
          width: 1, height: '100vh',
          background: '#16191c',
        }}>

        <Grid container>
          <Grid size={{ xs: 12, sm: 12, md: 12 }}>
            <Card sx={{
              width: 1, px: 4, minWidth: 210
            }} ref={cardRef}>
              <Box display={'flex'} alignItems={'center'} justifyContent={'center'}
                sx={{
                  width: 1, height: '80vh', p: 4
                }}>
                <Box>
                  <Box sx={{ textAlign: 'center', }}>
                    <Typography fontSize={16} fontWeight={800} color="#717171">Sign In Access</Typography>
                    <Typography fontSize={13} sx={{ my: 2 }} color="#717171">Welcome to widelapse monitoring system</Typography>
                  </Box>
                  <form autoComplete="false" onSubmit={handleSubmit((data) => {
                    console.log("FORM", data)
                    dispatch({ type: `${LOGIN}_AUTH`, payload: data });
                  })}>
                    <RFG labelStyle={{ color: "#717171" }} name="username" label="Username" control={control} rules={{ required: true }} className="mb-2">
                      <input autoComplete="false" style={{ borderRadius: 4, color: "white", background: '#16191c' }} />
                    </RFG>
                    <RFG labelStyle={{ color: "#717171" }} name="password" label="Password" control={control} rules={{ required: true }} className="mb-2">
                      <input style={{ borderRadius: 4, color: "white", background: '#16191c' }} />
                    </RFG>
                    <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#717171", cursor: 'pointer' }}
                      onClick={() => { navigate('/forgot-password/') }}
                    >Forgot Password</Typography>
                    <Button sx={{ width: 1, my: 3, background: '#ffd85f', borderRadius: 2 }} type="submit">Login</Button>
                  </form>

                  <Box fontSize={12} className="error">{user?.message}</Box>
                  <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                    <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#717171" }}>Powered by widelapse</Typography>
                    <Typography sx={{ mt: 2, fontSize: 12, textAlign: 'right', color: "#717171" }}>Terms & conditions</Typography>
                  </Box>
                </Box>
              </Box>
            </Card>
          </Grid>
        </Grid>


      </Box>
    </>
  )
}

